import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import AuthBottom from 'components/AuthBottom';
import AuthTop from 'components/AuthTop';
import AuthWrapper from 'components/AuthWrapper';
import FormErrors from 'components/FormErrors';
import ViewablePasswordField from 'components/ViewablePasswordField';
import Validators from 'utils/fieldValidators';
import { PASSWORD_RULE_DESCRIPTION } from 'utils/messages';
import './ChangePasswordForm.css';

class ChangePasswordForm extends Component {
  constructor(props) {
    super(props);

    this.toggleCurrentPasswordVisibility =
      this.toggleCurrentPasswordVisibility.bind(this);
    this.toggleNewPasswordVisibility =
      this.toggleNewPasswordVisibility.bind(this);
    this.toggleConfirmPasswordVisibility =
      this.toggleConfirmPasswordVisibility.bind(this);

    this.state = {
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false
    };
  }

  toggleCurrentPasswordVisibility() {
    this.setState({ showCurrentPassword: !this.state.showCurrentPassword });
  }

  toggleNewPasswordVisibility() {
    this.setState({ showNewPassword: !this.state.showNewPassword });
  }

  toggleConfirmPasswordVisibility() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }

  render() {
    const { error, handleSubmit, submitting, resetPassword } = this.props;

    const showCurrentPassword = this.state.showCurrentPassword;
    const showNewPassword = this.state.showNewPassword;
    const showConfirmPassword = this.state.showConfirmPassword;
    const title = resetPassword ? 'Reset Password' : 'Change Password';

    return (
      <form onSubmit={handleSubmit} className="change-password-form">
        <AuthWrapper aria-label={`${title} Form`}>
          <AuthTop hideLogo>
            <h1 className="form-title" aria-level="1">
              {title}
            </h1>
            <div className="form-subtitle">
              Change the password you use to sign into your account.
            </div>
            {error && <FormErrors errors={[error]} />}
            {!resetPassword && (
              <Field
                label="Current Password"
                type="password"
                name="oldPassword"
                placeholder="Current Password"
                component={ViewablePasswordField}
                toggleVisibility={this.toggleCurrentPasswordVisibility}
                showPassword={showCurrentPassword}
                autoComplete="current-password"
                disableOnSubmitting={true}
                validate={Validators.required}
              />
            )}
            <Field
              label="New Password"
              type="password"
              name="password"
              placeholder="New Password"
              component={ViewablePasswordField}
              toggleVisibility={this.toggleNewPasswordVisibility}
              showPassword={showNewPassword}
              autoComplete="new-password"
              disableOnSubmitting={true}
              tooltip={PASSWORD_RULE_DESCRIPTION}
              validate={Validators.password}
            />
            <Field
              label="Confirm New Password"
              type="password"
              name="confirmPassword"
              placeholder="Confirm New Password"
              component={ViewablePasswordField}
              toggleVisibility={this.toggleConfirmPasswordVisibility}
              showPassword={showConfirmPassword}
              autoComplete="new-password"
              disableOnSubmitting={true}
              validate={Validators.reduxConfirmPassword}
            />
          </AuthTop>
          <AuthBottom>
            <div className="submit-btn">
              <button
                className="button-color-green btn-block"
                disabled={submitting}
                type="submit"
              >
                <span>Save Changes</span>
              </button>
            </div>
          </AuthBottom>
        </AuthWrapper>
      </form>
    );
  }
}

export default reduxForm({
  form: 'changePasswordForm'
})(ChangePasswordForm);
